<script>
    export default {
        name: "login-window-footer",
        props: {
            versionText: {
                type: String,
                required: true
            }
        }
    }
</script>

<template>
    <div>
        <div class="login-window-footer">
            <slot />
        </div>
        <p class="mt-2">
            <small>{{versionText}}</small>
        </p>
    </div>
</template>

<style scoped>
    .login-window-footer {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }
</style>
